module.exports = __webpack_public_path__ + "img/9788963860008.c8f69bb4.jpg";